function Loader() {
  return (
    <div className="loadingLabel-container">
      <div className="loadingLabel">Loading...</div>
    </div>
  );
}

export default Loader;
